import { useState, useEffect, useRef } from 'react';
import config from '../config';
import { Service } from '../interfaces';
import { useSession } from '../contexts/SessionContext';

interface FilterCriteria {
  ean: string;
}

const useFetchDeviceServiceByEan = (filterCriteria: FilterCriteria) => {
  const [serviceResponse, setServiceResponse] = useState<Service[]>([]);
  const [error, setError] = useState<string | null>(null);
  const previousEanRef = useRef<string | null>(null);
    const { sessionState } = useSession();

  useEffect(() => {
    const fetchServiceDeviceByEan = async () => {
      try {
        const token = sessionState.account?.token;
        const response = await fetch(`${config.centralApiBaseUrl}/service/byean/${filterCriteria.ean}`, {
          method: 'GET',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch items');
        }

        const data = await response.json();
        console.log(data);
        setServiceResponse(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An unknown error occurred');
      }
    };
    if (filterCriteria.ean && filterCriteria.ean !== '' && filterCriteria.ean !== previousEanRef.current) {
      fetchServiceDeviceByEan();
      previousEanRef.current = filterCriteria.ean; // Update the previous EAN ref
      setError('');
    } else if (!filterCriteria.ean || filterCriteria.ean === '') {
      setError('EAN cannot be empty');
    }
  }, [filterCriteria, sessionState]);

  return { serviceResponse, error };
};

export default useFetchDeviceServiceByEan;
